module.exports = __webpack_public_path__ + "static/media/org_active.02c413e7.svg";